
export const messages = {
    "RESET_PASSWORD" : {
        "RESET_SAME_PASSWORD":"The new password cannot be the same as the current password. Please choose a different password.",
        "RESET_PASSWORD_SUCCESSFULLY":"Password updated successfully. Redirecting to Home.",
        "RESET_PASSWORD_MISMATCH":"Passwords don't match. Please confirm again."
    },
    "UNEXPECTED_ERROR_OCCURRED":"Something went wrong.",
    "DEFAULT_ROLE":"General"
};